import { AxiosError } from 'axios';

interface ErrorLogOptions {
  message: string;
  path?: string;
  detail?: Record<string, unknown>;
}

export enum LogLevel {
  ERROR = 'error',
  WARN = 'warn',
  INFO = 'info',
  DEBUG = 'debug',
}

export const logger = (
  level: LogLevel,
  error: unknown,
  options: ErrorLogOptions
) => {
  if (error && error instanceof AxiosError) {
    console.error(
      JSON.stringify({
        status: level,
        extra: {
          message: options.message,
          detail: {
            message: error.response?.data?.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            headers: error.response?.headers,
            data: error.response?.data,
            ...options.detail,
          },
        },
      })
    );
  } else {
    console.error(
      JSON.stringify({
        status: level,
        extra: {
          message: options.message,
          detail: {
            error: error instanceof Error ? error.message : String(error),
            ...options.detail,
          },
        },
      })
    );
  }
};
